import script from "./RecentlyViewedListingsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RecentlyViewedListingsComponent.vue?vue&type=script&setup=true&lang=js"

import "./RecentlyViewedListingsComponent.vue?vue&type=style&index=0&id=bd00ff46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd00ff46"]])

export default __exports__